var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgPaperBookmark(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M23.038 6.738v18.396h-14.3V11.372l.038-.191.073-.177.109-.162 3.884-3.884.162-.109.177-.073.19-.038h9.667zm-1 .999h-8.563l-3.738 3.738v12.658h12.301V7.737zm-6.514 12.816c.278 0 .417.22.412.436.004.192-.105.387-.324.428l-.088.008h-3.312c-.277 0-.416-.22-.412-.436-.005-.216.134-.436.412-.436h3.312zm3.986-2c.278 0 .418.22.412.436.005.192-.105.387-.324.428l-.088.008h-7.298c-.277 0-.416-.22-.412-.436-.005-.216.134-.436.412-.436h7.298zm0-2c.278 0 .418.22.412.436.005.192-.105.387-.324.428l-.088.008h-7.298c-.277 0-.416-.22-.412-.436-.005-.216.134-.436.412-.436h7.298zM19.4 9.8a.6.6 0 01.592.503L20 10.4v3.69a.6.6 0 01-.892.525l-.085-.058-1.024-.826-1.022.826a.6.6 0 01-.683.05l-.085-.061-.076-.078a.6.6 0 01-.124-.276L16 14.091V10.4a.6.6 0 01.503-.592L16.6 9.8h2.8zm-.4 1h-2v2.452l1-.806 1 .807V10.8z"
  }));
}

export default SvgPaperBookmark;